import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	ModalTransition,
} from '@atlaskit/modal-dialog';

import { messages } from '../../../messages';

interface ConfirmationCloseModalProps {
	isOpen: boolean;
	onCancelClicked: () => void;
	onClose: () => void;
	onConfirmClicked: () => void;
	shouldReturnFocus?: boolean | React.RefObject<HTMLElement>;
}

export const ConfirmationCloseModal = ({
	isOpen,
	shouldReturnFocus,
	onClose,
	onCancelClicked,
	onConfirmClicked,
}: ConfirmationCloseModalProps): React.JSX.Element => {
	const intl = useIntl();

	return (
		<ModalTransition>
			{isOpen && (
				<Modal
					onClose={onClose}
					testId="sidebar-confirmation-modal"
					shouldReturnFocus={shouldReturnFocus}
				>
					<ModalHeader hasCloseButton>
						<ModalTitle appearance="warning">
							{intl.formatMessage(messages.confirmationModalTitle)}
						</ModalTitle>
					</ModalHeader>
					<ModalBody>{intl.formatMessage(messages.confirmationModalDescription)}</ModalBody>
					<ModalFooter>
						<Button
							testId="sidebar-confirmation-modal-cancel-btn"
							appearance="subtle"
							onClick={onCancelClicked}
						>
							{intl.formatMessage(messages.confirmationModalCancel)}
						</Button>
						<Button
							testId="sidebar-confirmation-modal-confirm-btn"
							appearance="warning"
							onClick={onConfirmClicked}
						>
							{intl.formatMessage(messages.confirmationModalConfirm)}
						</Button>
					</ModalFooter>
				</Modal>
			)}
		</ModalTransition>
	);
};
